
import ProductInfoCard from "../ui/productInfoCard";
import BottomCart from "../ui/bottom-cart";
import { useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { cartContext } from "../../App";
import HeaderOther from "../ui/header-other";
import './display-product.css';

export default function DisplayProducts() {
    const { productDataList, maxAmountReached } = useContext(cartContext);
    const location = useLocation();
    const {
        category,
        name,
        productList,
        productTypeId,
        productGroupId,
        subcategoryId,
        categoryId,
        brand,
        dataList,
    } = location.state || {};

    const [data, setData] = useState([]);

    useEffect(() => {
        const cat = String(category || '')
            .split(',')
            .map((c) => c.trim().toLowerCase())
            .filter(Boolean);
        const typeIds = Array.isArray(productTypeId)
            ? productTypeId.map((id) => String(id).toLowerCase())
            : String(productTypeId || '')
                  .split(',')
                  .map((id) => id.trim().toLowerCase())
                  .filter(Boolean);
        const groupIds = Array.isArray(productGroupId)
            ? productGroupId.map((id) => String(id).toLowerCase())
            : String(productGroupId || '')
                  .split(',')
                  .map((id) => id.trim().toLowerCase())
                  .filter(Boolean);
        const subIds = Array.isArray(subcategoryId)
            ? subcategoryId.map((id) => String(id).toLowerCase())
            : String(subcategoryId || '')
                  .split(',')
                  .map((id) => id.trim().toLowerCase())
                  .filter(Boolean);
        const catIds = Array.isArray(categoryId)
            ? categoryId.map((id) => String(id).toLowerCase())
            : String(categoryId || '')
                  .split(',')
                  .map((id) => id.trim().toLowerCase())
                  .filter(Boolean);
        const brands = Array.isArray(brand)
            ? brand.map((b) => String(b).toLowerCase())
            : String(brand || '')
                  .split(',')
                  .map((b) => b.trim().toLowerCase())
                  .filter(Boolean);

        const filtered = productDataList.filter((item) => {
            const categoryValue = String(item.data.category || '').toLowerCase();
            const typeValue = String(item.data.productTypeId || '').toLowerCase();
            const groupValue = String(item.data.productGroupId || '').toLowerCase();
            const subValue = String(item.data.subcategoryId || '').toLowerCase();
            const catIdValue = String(item.data.categoryId || '').toLowerCase();
            const brandValue = String(item.data.brand || '').toLowerCase();

            return (
                (cat.length && cat.includes(categoryValue)) ||
                (typeIds.length && typeIds.includes(typeValue)) ||
                (groupIds.length && groupIds.includes(groupValue)) ||
                (subIds.length && subIds.includes(subValue)) ||
                (catIds.length && catIds.includes(catIdValue)) ||
                (brands.length && brands.includes(brandValue))
            );
        });

        if (
            !category &&
            !productTypeId &&
            !productGroupId &&
            !subcategoryId &&
            !categoryId &&
            !brand &&
            Array.isArray(dataList)
        ) {
            setData(dataList);
        } else if (productList) {
            setData(productList);
        } else {
            setData(filtered);
        }
    }, [category, productList, productDataList, productTypeId, productGroupId, subcategoryId, categoryId, brand, dataList]);

    return (
        <>
            {maxAmountReached && (
                <div className="max-amount-reached">
                    <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                </div>
            )}
            <HeaderOther title={name}/>
            <div className="container" style={{ marginTop: '10px' }}>
                <ProductInfoCard dataList={data} />
            </div>
            <BottomCart />
        </>
    );
}



